export const css = {
    root: '_1OCFC8lG',
    calendar: 'wDiVmIYS',
    inactiveDate: '_3Jho9Aa7',
    valid: '_3GrJPR05',
    invalid: '_36gdTKPi',
    'focus-visible': '_2nskI5zV',
    ' _key': 'base-widgets/date-input/date-input'
};
export default css;
